import { GetListParams } from 'react-admin';
import {
  CustomDataProvider,
  registerModuleDataProvider,
} from '../../../providers/CustomDataProvider';
import {
  DepositWalletFilters,
  listDepositWallets,
} from '../../../services/xbitRelayService';
import { DEFAULT_DEPOSIT_WALLETS_PROVIDER } from './constants';

const resourceName = 'xbit-relay/deposit-wallets';

const pickFilter = (filter: any): DepositWalletFilters => {
  if (!filter) return {};
  const out: DepositWalletFilters = {};
  if (filter.userId) out.userId = filter.userId;
  if (filter.address) out.address = filter.address;
  return out;
};

export const xbitRelayDepositWalletsDataProvider: CustomDataProvider = {
  async getList(_resource: string, params: GetListParams): Promise<any> {
    const { page = 1, perPage = 20 } = params.pagination || {};
    const filter = params.filter || {};
    const provider = filter.provider || DEFAULT_DEPOSIT_WALLETS_PROVIDER;

    const response = await listDepositWallets({
      ...pickFilter(filter),
      provider,
      page,
      pageSize: perPage,
    });

    const { items = [], total } = response.data || ({} as any);
    return {
      data: items.map((item) => ({ ...item, id: item.id })),
      total: Number(total) || 0,
    };
  },
};

registerModuleDataProvider(resourceName, xbitRelayDepositWalletsDataProvider);
